import { BaseDto } from "@/shared/dtos/base-dto";

export class grupo_dashboard extends BaseDto {
  public nombre!: string;
  public icono!: string;
}
